// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconKbtc } from "../../../icons/full/build/icon-kbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const KbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconKbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  KbtcIcon.displayName = 'KbtcIcon';
}

export default KbtcIcon;